var scope_0 = require('/home/runner/work/express-add-ons-docs/express-add-ons-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b2acbc5d713cf3aee4b9a069e6de47a6.js').default;
var scope_1 = require('/home/runner/work/express-add-ons-docs/express-add-ons-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    